import React from 'react';

const StarSvg = (props) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      {...props}
    >
      <path
        d='M6.21424 3.74964C7.10089 2.15906 7.54419 1.36377 8.20702 1.36377C8.86985 1.36377 9.31316 2.15905 10.1998 3.74963L10.4292 4.16113C10.6812 4.61313 10.8071 4.83913 11.0036 4.98824C11.2 5.13736 11.4446 5.1927 11.9339 5.30341L12.3794 5.4042C14.1011 5.79377 14.962 5.98855 15.1668 6.64719C15.3717 7.3058 14.7848 7.99215 13.6109 9.36471L13.3073 9.71982C12.9737 10.1099 12.8069 10.3049 12.7319 10.5462C12.6569 10.7875 12.6821 11.0477 12.7325 11.5681L12.7784 12.0419C12.9559 13.8732 13.0446 14.7889 12.5084 15.1959C11.9722 15.603 11.1661 15.2318 9.55403 14.4896L9.13697 14.2975C8.67889 14.0866 8.44985 13.9811 8.20702 13.9811C7.96419 13.9811 7.73515 14.0866 7.27708 14.2975L6.86002 14.4896C5.2479 15.2318 4.44185 15.603 3.90563 15.1959C3.36941 14.7889 3.45815 13.8732 3.63561 12.0419L3.68152 11.5681C3.73195 11.0477 3.75716 10.7875 3.68213 10.5462C3.60711 10.3049 3.44033 10.1099 3.10677 9.71982L2.8031 9.36471C1.62931 7.99215 1.04241 7.3058 1.24723 6.64719C1.45205 5.98855 2.31293 5.79377 4.03471 5.4042L4.48015 5.30341C4.96942 5.1927 5.21406 5.13736 5.41049 4.98824C5.60691 4.83913 5.7329 4.61313 5.98486 4.16113L6.21424 3.74964Z'
        stroke='currentColor'
      />
    </svg>
  );
};

export default StarSvg;
